import {
  Button,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Text,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import iconFile from "../../assets/images/timeKeeping/file.svg";

export function FuelSearchInput({ onChange }) {
  return (
    <InputGroup
      maxW="42vw"
      minW={"42vw"}
      borderRadius={{ base: "8px" }}
      w={{ base: "100%" }}
    >
      <Input
        placeholder="Tên NV, mã NV ..."
        type="text"
        borderRadius={{ base: "8px" }}
        border={{ base: "1px solid var(--color-boder)" }}
        backgroundColor={"var(--fill-avatar)"}
        onChange={(e) => onChange(e.target.value)}
      />
      <InputRightElement
        borderTopRightRadius={"8px"}
        borderBottomRightRadius={"8px"}
        pointerEvents="none"
        backgroundImage="var(--color-button)"
      >
        <SearchIcon color="var(--color-main)" />
      </InputRightElement>
    </InputGroup>
  );
}

export function FuelExportButton({ onClick }) {
  return (
    <Button
      display="flex"
      alignItems="center"
      p="10px 16px"
      gap="8px"
      backgroundImage="var(--color-gradient-excel)"
      onClick={onClick}
    >
      <Image src={iconFile} />
      <Text fontSize="15px" fontWeight={600} color="var(--color-main)">
        Xuất excel
      </Text>
    </Button>
  );
}
